import React, { useContext, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toastMsg } from "../component/toast";
import { AppContext } from "../context/AppContext";
import { PostCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import CustomButton from "../component/button";

function AddNotes({ isAddNotes, setIsAddNotes, notes, userId, setNotes, userName, codeId, handleGetNotes, getList, code }) {


  const [newNote, setNewNote] = useState("");

  const [isLoading, setIsloading] = useState(false)

  const { adminData } = useContext(AppContext)

  const handleAddNote = () => {

    let n = newNote?.trim()

    if (!n) {
      toastMsg('error', 'Please Enter Note To Add')

      return
    }

    let payload = {
      "userId": userId,
      "codeId": codeId,
      "email": adminData?.email,
      "note": n
    }

    setIsloading(true)

    PostCallWithErrorResponse(ApiConfig.ADD_NOTE, payload).then((res) => {

      if (res?.json?.succeded) {
        toastMsg('success', res?.json?.message)
        handleGetNotes(codeId, userId)
        setNewNote("");
        getList(code)
      }

      setIsloading(false)

    })




  };

  return (
    <Modal
      show={isAddNotes}
      size="lg"
      centered
      dialogClassName="modal-h-650"
      onHide={() => {

        setIsAddNotes(false)

        setNotes([])

      }}
    >
      <Modal.Header closeButton className="custom-close-btn">
        <h4 className="mb-0 mt-1 fw-medium">{userName}</h4>
      </Modal.Header>

      <Modal.Body>
        <div style={{
          minHeight: '330px', maxHeight: '330px', overflow: 'scroll', scrollbarWidth: "none",     // Firefox
          msOverflowStyle: "none"
        }}>
          {notes.map((note, index) => (
            <div key={index} className="mb-2">
              <div className="d-flex justify-content-between">
                <small>{note.writer}</small>
                <small>{note.email}</small>
              </div>
              <div style={{ padding: '4px', border: '1px solid var(--ui-border)', borderRadius: '5px', fontFamily: 'inter-regular' }}>
                {note.notes}
              </div>
              {/* <Form.Control
                as="textarea"
                rows={2}
                value={note.notes}
                readOnly
                className="mt-1"
              /> */}
              <div className="d-flex justify-content-end">
                <small>{note?.createdAt?.split("T")[0] + ' ' + note?.createdAt?.split("T")[1]?.split(".")[0]}</small>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-3">
          <Form.Label className="fw">Add Note:</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            className="note-input"
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            placeholder="Write your note here..."
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton title="Add"
          handleClick={handleAddNote}
          isLoading={isLoading}
        />

      </Modal.Footer>
    </Modal >
  );
}

export default AddNotes;
